import { DefaultValue, Description, Hint, Required, Width } from "./configurables";
import { AutoFill } from "./configurables/AutoFill";
import { Conditional } from "./configurables/Conditional";
import { HashCode } from "./configurables/HashCode";
import { TextField } from "./TextField";

export class IntegerField extends TextField {
    public icon = "sort-numeric-asc";
    public fieldType = "Reine Zahl";

    constructor(field) {
        super(field);
    }

    public getConfigurables() {
        return [HashCode, AutoFill, Conditional, Required, Description, DefaultValue, Width, Hint];
    }
}
